"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = require("prop-types");

var _Button = require("./Button.styles");

var _icons = require("../../assets/icons");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var icons = {
  check: (0, _jsxRuntime.jsx)(_icons.Check, {}),
  arrowLeft: (0, _jsxRuntime.jsx)(_icons.ArrowLeft, {}),
  chevronRight: (0, _jsxRuntime.jsx)(_icons.ChevronRight, {})
};
var ButtonContainer = (0, _base["default"])("button", {
  target: "e125xtwd0",
  label: "ButtonContainer"
})("display:inline-flex;align-items:center;justify-content:center;position:relative;overflow:hidden;text-decoration:none;", function (props) {
  return props.btnType === 'icon' ? (0, _Button.iconButtonStyles)(props) : (0, _Button.dynamicStyles)(props);
}, ";");

var Button = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var as = _ref.as,
      children = _ref.children,
      type = _ref.type,
      icon = _ref.icon,
      customIcon = _ref.customIcon,
      size = _ref.size,
      htmlType = _ref.htmlType,
      onClick = _ref.onClick,
      onBlur = _ref.onBlur,
      className = _ref.className,
      disabled = _ref.disabled,
      href = _ref.href,
      target = _ref.target,
      download = _ref.download,
      rel = _ref.rel,
      value = _ref.value,
      form = _ref.form,
      active = _ref.active,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["as", "children", "type", "icon", "customIcon", "size", "htmlType", "onClick", "onBlur", "className", "disabled", "href", "target", "download", "rel", "value", "form", "active"]);
  return (0, _jsxRuntime.jsxs)(ButtonContainer, _objectSpread(_objectSpread({
    as: as,
    type: htmlType,
    btnType: type,
    size: size,
    iconOnly: !children,
    ref: ref,
    onClick: onClick,
    className: (0, _clsx["default"])('grui', {
      'custom-icon': customIcon
    }, className),
    disabled: disabled,
    href: href,
    target: target,
    download: download,
    rel: rel,
    onBlur: onBlur,
    value: value,
    active: active,
    form: form
  }, otherProps), {}, {
    children: [icon && icons[icon], customIcon && customIcon, children && type === 'icon' ? children : (0, _jsxRuntime.jsx)("span", {
      children: children
    })]
  }));
});

Button.propTypes = {
  as: _propTypes.elementType,
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  type: (0, _propTypes.oneOf)(['primary', 'secondary', 'tertiary', 'warning', 'warningOutline', 'note', 'icon']),
  // Button element's type attribute
  htmlType: (0, _propTypes.oneOf)(['button', 'submit', 'reset']),
  // Button with icon
  icon: (0, _propTypes.oneOf)(['check', 'arrowLeft', 'chevronRight']),
  customIcon: _propTypes.node,
  size: (0, _propTypes.oneOf)(['big', 'small']),
  onClick: _propTypes.func,
  onBlur: _propTypes.func,
  className: _propTypes.string,
  disabled: _propTypes.bool,

  /*
   * Accept a tag's attributes
   */
  href: _propTypes.string,
  target: (0, _propTypes.oneOf)(['_self', '_parent', '_top', '_blank']),
  download: _propTypes.string,
  rel: _propTypes.string,
  value: _propTypes.string,

  /**
   * Only for icon type
   */
  active: _propTypes.bool,
  // Form id: for trigger submit on form that is not button's parent
  form: _propTypes.string
};
Button.defaultProps = {
  // can be A tag too
  as: 'button',
  children: undefined,
  type: 'primary',
  htmlType: 'button',
  icon: undefined,
  customIcon: undefined,
  size: 'big',
  onClick: function onClick() {},
  onBlur: function onBlur() {},
  className: undefined,
  disabled: false,
  href: undefined,
  target: undefined,
  download: undefined,
  rel: undefined,
  value: undefined,
  active: false,
  form: undefined
};
Button.displayName = 'Button';
var _default = Button;
exports["default"] = _default;
//# sourceMappingURL=Button.js.map